import { useLoaderData } from "react-router-dom";

import { calculateAge, formatDate } from "../../../../../ui library/helpers/functions";

import { HeaderDetailRows } from "./HeaderDetailRows";
import { formatCurrencyValue } from "./utils/detailsHelpers";

const Details = ({ formHeader: formHeaderProp }) => {
  const { followUp } = useLoaderData() || {};
  const formHeader = formHeaderProp ?? followUp?.formHeader;

  if (!formHeader) {
    return null;
  }

  const headerType = formHeader?.header_type ?? "default_action_item_header";
  const age = formHeader?.client_dob ? calculateAge(formHeader.client_dob) : null;
  const dob = formHeader?.client_dob ? formatDate(formHeader.client_dob) : "N/A";
  const dobWithAge = dob !== "N/A" && age !== null ? `${dob} (${age})` : dob;

  const renderStat = (label, value) => (
    <div className="grid min-w-[140px]">
      <p className="text-sm font-semibold">{label}:</p>
      <span className="text-3xl font-light leading-tight">{formatCurrencyValue(value)}</span>
    </div>
  );

  return (
    <article className="mb-8 w-full">
      <h3 className="text-2xl font-semibold">{formHeader?.client_name ?? "N/A"}</h3>
      <div className="flex gap-4 max-[1312px]:flex-col md:items-start md:justify-between min-[1313px]:flex-row">
        <div className="min-w-[530px]">
          <div className="mt-3 flex flex-wrap gap-6">
            {renderStat("Medical Limits", formHeader?.medical_limit)}
            <div className="hidden h-12 border-r-2 border-gray-200 md:block"></div>
            {renderStat("Verbal Balance", formHeader?.verbal_balance)}
            <div className="hidden h-12 border-r-2 border-gray-200 md:block"></div>
            {renderStat("Received Bill Charges", formHeader?.received_bill_charges)}
            <div className="hidden h-12 border-r-2 border-gray-200 md:block"></div>
          </div>
        </div>

        <div
          className={`grid flex-1 gap-2 md:w-2/5 ${
            headerType === "document_focused_header" ? "md:grid-cols-2" : "grid-cols-1"
          }`}
        >
          <HeaderDetailRows
            headerType={headerType}
            formHeader={formHeader}
            dobWithAge={dobWithAge}
          />
        </div>
      </div>
    </article>
  );
};

export default Details;
